import { ConsentTermsId } from "@/data/payload/app-account-setting/add-app-account-request-payload";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

/**
 * 보호자 동의 약관 마크다운 파일(본문·버전)을 조회한다.
 * 04 이용약관 동의 화면의 처리방침 고지(Privacy)와 동의 시트의 약관 전문(TermsOfService·Research·Marketing)에 공통으로 쓴다.
 */
export class FetchConsentTermsFileUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(
    termsId: ConsentTermsId,
    locale: string,
  ): Promise<SATResult<ParentalConsentInfo, SATError>> {
    return this.appAccountSettingRepo.fetchConsentTermsFile(termsId, locale);
  }
}
